<template>
  <section class="multi-select-filter">
    <sk-multiselect :items-list="selectList"
                    :preselected-value="selectedOptions"
                    :default-value="placeholder"
                    @checkboxeschanged="onInputBoxChanged" />
  </section>
</template>

<script>
  export default {
    data() {
      return {
        selectedOptions: []
      };
    },
    computed: {
      // should be overridden by extending component
      selectList() {
        return [{id: '-1', name: 'None'}];
      },
      placeholder() { return this.$gettext('Select'); },

    },
    methods: {
      onInputBoxChanged(value) {
        this.selectedOptions = [...value];
        if (this.selectedOptions === '') {
          return;
        }
        this.params.parentFilterInstance((instance) => {
          instance.onFloatingFilterChanged('inList', value);
        });
      },

      onParentModelChanged(parentModel) {
        // When the filter is empty we will receive a null value here
        if (!parentModel) {
          this.selectedOptions = '';
        }
      }
    }
  };
</script>

<style>
.multi-select-filter .sk-select {
  background-color: #fff;
}

.multi-select-filter .sk-select__list {
  width: fit-content;
}

.multi-select-filter .sk-select__value {
  color: #333;
  font-weight: normal;
  font-size: 13px;
}

.multi-select-filter {
  width: 100%;
}
</style>
